import Header from '../components/general/Header'
import Footer from '../components/general/Footer'
import ContenidoLogin from '../components/cuentas/ContenidoRegistrar.jsx'
import MetaData from '../context/MetaData'

export default function Login(){
    return(
        <div>         
            <MetaData titulo="Registro"/>
            <Header>            
            </Header>
            <ContenidoLogin></ContenidoLogin>
            <Footer></Footer>
        </div>
    );
}
